(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2532],{

/***/ 15800:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/game/[slug]",
      function () {
        return __webpack_require__(63605);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 70055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* reexport */ BreadCrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./src/contexts/HighlightContext/Highlight.tsx
var Highlight = __webpack_require__(78958);
// EXTERNAL MODULE: ./src/components/Link/index.tsx
var Link = __webpack_require__(7500);
// EXTERNAL MODULE: ./node_modules/@mui/material/Breadcrumbs/Breadcrumbs.js + 3 modules
var Breadcrumbs = __webpack_require__(12963);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(29769);
// EXTERNAL MODULE: ./src/contexts/AppContext/index.tsx + 6 modules
var AppContext = __webpack_require__(13560);
// EXTERNAL MODULE: ./node_modules/next-translate-routes/index.js
var next_translate_routes = __webpack_require__(18633);
;// CONCATENATED MODULE: ./src/utils/filter-breadcrumbs.ts

function filterBreadcrumbs(useCollectionCrumbs, data, locale, currentCollection) {
    var ref;
    var url = "".concat((ref = "https://5np9q0y8qc5.site.byorbit.com/") === null || ref === void 0 ? void 0 : ref.replace(/\/+$/, ""));
    var breadcrumbs = data;
    if (useCollectionCrumbs) {
        var filteredCrumbs = breadcrumbs.filter(function(crumb) {
            var ref;
            return !(crumb === null || crumb === void 0 ? void 0 : (ref = crumb.type) === null || ref === void 0 ? void 0 : ref.includes("category"));
        });
        if ((currentCollection === null || currentCollection === void 0 ? void 0 : currentCollection.name) && (currentCollection === null || currentCollection === void 0 ? void 0 : currentCollection.slug)) {
            return filteredCrumbs.map(function(crumb) {
                var translatedCollection = (0,next_translate_routes.translateUrl)("/collection/".concat(crumb.code), locale);
                if (crumb.path.includes(translatedCollection)) {
                    return {
                        href: "".concat(url).concat((0,next_translate_routes.translateUrl)("/collection/".concat(currentCollection.slug), locale)),
                        path: "".concat((0,next_translate_routes.translateUrl)("/collection/".concat(currentCollection.slug), locale)),
                        name: currentCollection.name
                    };
                }
                return crumb;
            });
        }
        return filteredCrumbs;
    } else {
        return breadcrumbs.filter(function(crumb) {
            var translatedCollection = (0,next_translate_routes.translateUrl)("/collection/".concat(crumb.code), locale);
            return !crumb.path.includes(translatedCollection);
        });
    }
}

;// CONCATENATED MODULE: ./src/components/BreadCrumbs/BreadCrumbs.tsx











var BreadCrumbs_Link = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Link/* Link */.r, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
function BreadCrumbs(props) {
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "breadcrumb"
    ]).t;
    var breadcrumbFilter = props.breadcrumbs.map(function(breadcrumb) {
        return breadcrumb.path === "/" ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, breadcrumb), {
            name: t("breadcrumb:home")
        }) : breadcrumb;
    });
    var currentCollection = appContext.useCollectionCrumbs().currentCollection;
    var ref = appContext.useConfig(), languageCode = ref.languageCode, componentOptions = ref.componentOptions;
    var breadcrumbs = filterBreadcrumbs(componentOptions.component_use_collection_crumbs || false, breadcrumbFilter, languageCode, currentCollection);
    var theme = (0,useTheme/* default */.Z)();
    var crumbRefs = react.useRef([]);
    // Todo: Fix crumbRefs.current typescript problem.
    // @ts-ignore
    crumbRefs.current = breadcrumbs.map(function(crumb, index) {
        var _index;
        // @ts-ignore
        return (_index = crumbRefs.current[index]) !== null && _index !== void 0 ? _index : /*#__PURE__*/ react.createRef();
    });
    if (!(props === null || props === void 0 ? void 0 : props.hidden)) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Breadcrumbs/* default */.Z, {
        "aria-label": "breadcrumb",
        sx: {
            margin: theme.spacing(2, 0)
        },
        children: breadcrumbs.map(function(crumb, index) {
            return breadcrumbs[breadcrumbs.length - 1] ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BreadCrumbs_Link, {
                // @ts-ignore
                ref: crumbRefs.current[index],
                underline: "hover",
                color: "text.primary",
                href: crumb.path,
                "aria-current": "page",
                variant: "body2",
                sx: {
                    textTransform: "none"
                },
                children: crumb.name === "Home" ? t("home", "Home") : crumb.name
            }, index) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BreadCrumbs_Link, {
                // @ts-ignore
                ref: crumbRefs.current[index],
                underline: "hover",
                color: "inherit",
                href: crumb.path,
                variant: "body2",
                sx: {
                    textTransform: "none"
                },
                children: crumb.name
            }, index);
        })
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
}

;// CONCATENATED MODULE: ./src/components/BreadCrumbs/index.ts



/***/ }),

/***/ 95073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* reexport */ ImageLoaderWrapper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/utils/is-valid-url.ts
var isValidUrl = function(url) {
    // Check if the url is a valid url or not.
    return /^https?:\/\//.test(url || "");
};

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
;// CONCATENATED MODULE: ./src/components/ImageLoaderWrapper/ImageLoaderWrapper.tsx







/**
 * Calculates the proper height of an image with a custom width, preserving the original aspect ratio.
 *
 * @param originalHeight
 * @param originalWidth
 * @param newWidth
 */ function determineNewHeight(originalHeight, originalWidth, newWidth) {
    return Math.ceil(originalHeight / originalWidth * newWidth);
}
var ImageContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((image_default()), {
    target: "epyx9ne0"
})(function(param) {
    var theme = param.theme;
    return {
        objectFit: "cover"
    };
});
var ImageLoaderWrapper = function(props) {
    var height = props.height, width = props.width, grayscale = props.grayscale, format = props.format, layout = props.layout, alt = props.alt, _rszHeight = props.rszHeight, rszHeight = _rszHeight === void 0 ? true : _rszHeight, other = (0,_object_without_properties/* default */.Z)(props, [
        "height",
        "width",
        "grayscale",
        "format",
        "layout",
        "alt",
        "rszHeight"
    ]);
    var loader = function(loaderProps) {
        var q = loaderProps.quality, w = loaderProps.width, src = loaderProps.src;
        // TODO: Check if the provided src is a valid url or not, if yes return it directly.
        var validUrl = isValidUrl(src.replace(/\/+$/, "").replace("/media/", ""));
        // Can find the query properties here;
        // https://gitlab.azerdev.com/huz.byorbit/huz-media/-/blob/master/src/asset/index.js
        // Todo: HUZ2ERA-1106 - Seems our media server won't allow us to resize webp assets by ratio operation.
        // let url = `${src.replace(/\/+$/, '')}/?qty=${q || 75}&fmt=${format || 'webp'}&ar[r]=${width}x${height}&ar[w]=${w}`;
        // let url = `${src.replace(/\/+$/, '')}/?qty=${q || 75}&fmt=${format || 'webp'}&rsz[w]=${w}`;
        var url = "".concat(src.replace(/\/+$/, ""), "/?fmt=").concat(format || "webp", "&rsz");
        // if (rszHeight) {
        //   url += `&rsz[h]=${determineNewHeight(height, width, w)}`;
        // }
        if (grayscale) url += "&gsc=".concat(grayscale);
        // TODO: Remove the conditional logic after updating all the existing sites.
        return validUrl && src.includes("https://media-aws-dev.byorbit.com") ? src.replace("/media/", "") : validUrl ? src.replace("/media/", "").replace(/\/+$/, "") : url;
    };
    // Make sure we don't pass width and height when layout is set to 'fill'. Refer to Next/image docs.
    return layout === "fill" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        alt: alt,
        layout: layout,
        loader: loader,
        height: "100%"
    })) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        alt: alt,
        width: width,
        height: height,
        loader: loader
    }));
};

;// CONCATENATED MODULE: ./src/components/ImageLoaderWrapper/index.ts



/***/ }),

/***/ 96410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ SubscriptionModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97582);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(35944);
/* harmony import */ var _mui_icons_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47727);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(473);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83321);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87357);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16829);
/* harmony import */ var next_translate_routes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18633);
/* harmony import */ var next_translate_routes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_translate_routes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _contexts_AuthenticationContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43477);










var ModalContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    target: "e16465q70"
})(function() {
    return {
        background: "linear-gradient(0deg, #000000 0%, #191040b5 30%, rgba(0,212,255,0) 100%)",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
        cursor: "default",
        button: {
            transition: "0.01s",
            "&:hover": {
                background: "#3352fe",
                outline: "1px solid white"
            }
        }
    };
});
var HeaderContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e16465q71"
})(function() {
    return {
        fontSize: "54px",
        fontWeight: "600",
        textTransform: "uppercase",
        p: {
            color: "white"
        },
        "@media screen and (max-width: 800px)": {
            fontSize: "24px"
        }
    };
});
var HeaderSubText = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e16465q72"
})(function() {
    return {
        color: "orange",
        marginBottom: "16px"
    };
});
var LoginButtonContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e16465q73"
})(function() {
    return {
        position: "absolute",
        right: "16px",
        top: "16px",
        display: "block",
        "@media screen and (max-width: 800px)": {
            display: "none"
        }
    };
});
var PrimaryButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    target: "e16465q74"
})(function() {
    return {
        background: "#3352fe",
        padding: "8px 24px",
        color: "white",
        fontSize: "18px"
    };
});
var StartButtonContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    target: "e16465q75"
})(function() {
    return {
        background: "#3352fe",
        padding: "12px 32px",
        color: "white",
        fontSize: "18px",
        "@media screen and (max-width: 800px)": {
            maxWidth: "calc(100% - 24px)"
        }
    };
});
var BoxContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    target: "e16465q76"
})(function() {
    return {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        paddingBottom: 3,
        width: "80vw",
        height: "80vh",
        outline: "none",
        paddingTop: 2,
        background: 'url("/images/settings-bg.png")',
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
        borderBottom: "2px solid #3352fe",
        "@media screen and (max-width: 800px)": {
            backgroundSize: "auto 100%"
        }
    };
});
var ListContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e16465q77"
})(function() {
    return {};
});
var ListItem = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e16465q78"
})(function() {
    return {
        display: "flex",
        alignItems: "center",
        margin: "8px 0",
        color: "white",
        svg: {
            marginRight: "8px",
            height: "32px",
            width: "32px"
        }
    };
});
var TextUnderline = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("a", {
    target: "e16465q79"
})(function() {
    return {
        cursor: "pointer",
        color: "white",
        textDecoration: "underline",
        "&:hover": {
            color: "#fafafa",
            textDecorationThickness: "2px"
        }
    };
});
var SubscriptionModal = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_0__.useState(true), 2), openState = ref[0], setOpenState = ref[1];
    var userToken = (0,_contexts_AuthenticationContext__WEBPACK_IMPORTED_MODULE_3__/* .useAuthenticationContext */ .l)().userToken;
    var handleClose = function() {
        setOpenState(false);
    };
    var router = (0,next_translate_routes__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var redirectAzcConnect = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                router.push("/subscription/auth");
                return [
                    2
                ];
            });
        });
        return function redirectAzcConnect() {
            return _ref.apply(this, arguments);
        };
    }();
    return openState ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(ModalContainer, {
        open: !userToken && openState,
        onClose: handleClose,
        "aria-labelledby": "modal-modal-title",
        "aria-describedby": "modal-modal-description",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)(BoxContainer, {
            sx: {
                bgcolor: "background.paper",
                boxShadow: 24,
                px: 4
            },
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(LoginButtonContainer, {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(PrimaryButton, {
                        color: "primary",
                        onClick: redirectAzcConnect,
                        children: "Login"
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)(HeaderContainer, {
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)("p", {
                            style: {
                                marginTop: "24px",
                                marginBottom: 0
                            },
                            children: " Play all of huz."
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)("p", {
                            style: {
                                margin: "8px 0"
                            },
                            children: "Try us, cancel at anytime "
                        })
                    ]
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)("div", {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(HeaderSubText, {
                        children: "Enjoy and play unlimited online games for only $4.99/month"
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(ListContainer, {
                    children: [
                        "No Advirtesement",
                        "Unlimited gameplays",
                        "Cancel at anytime",
                        "Play on any device",
                        "Children Account", 
                    ].map(function(i) {
                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)(ListItem, {
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_mui_icons_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                    style: {
                                        color: "green"
                                    }
                                }),
                                i
                            ]
                        }, i);
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)("div", {
                    style: {
                        position: "absolute",
                        bottom: "32px"
                    },
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)("div", {
                            style: {
                                marginBottom: "12px",
                                color: "white"
                            },
                            children: [
                                "HUZ is a subscription service. To see Terms and Conditions",
                                " ",
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(TextUnderline, {
                                    href: "https://static.gamedistribution.com/terms/both.html",
                                    children: "click here."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(StartButtonContainer, {
                            color: "primary",
                            onClick: redirectAzcConnect,
                            children: "Start Your Game Adventure"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)("div", {
                            style: {
                                marginTop: "12px",
                                color: "white"
                            },
                            children: [
                                "You can cancel anytime, ",
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(TextUnderline, {
                                    onClick: handleClose,
                                    children: "or try later"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .Fragment */ .HY, {});
};


/***/ }),

/***/ 61546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* reexport */ Title; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./src/contexts/CursorContext/Cursor.tsx
var Cursor = __webpack_require__(52746);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
;// CONCATENATED MODULE: ./src/components/Title/@editor/index.ts


var useEditorHandlers = function(name) {
    var theme = (0,useTheme/* default */.Z)();
    return (0,Cursor/* useCursorHandlers */.h)({
        name: name,
        styles: [
            {
                name: "theme_component_title_color",
                label: "General text color",
                type: "color",
                default: theme.palette.text.primary
            },
            {
                name: "theme_component_title_title_color",
                label: "Title text color",
                type: "color",
                default: theme.palette.text.primary
            },
            {
                name: "theme_component_title_link_hover_color",
                label: "Link text hover color",
                type: "color",
                default: theme.palette.action.hover
            },
            {
                name: "theme_component_title_link_active_color",
                label: "Link text active color",
                type: "color",
                default: theme.palette.action.active
            },
            {
                name: "theme_component_card_title_font_size",
                label: "Title font size",
                endAdornment: "px",
                type: "text",
                default: theme.typography.h2.fontSize
            },
            // 
            // {
            //   name: 'theme_component_title_padding',
            //   label: 'Padding',
            //   type: 'text',
            //   default: theme.spacing(1, 2),
            //   helperText: 'Define as top right left bottom; e.g.: 2px 10px 5px 10px',
            // },
            {
                name: "theme_component_title_lg_padding",
                label: "Padding for large screens",
                type: "text",
                default: theme.spacing(1, 2),
                helperText: "Define as top right left bottom; e.g.: 2px 10px 5px 10px"
            },
            // {
            //   name: 'theme_component_title_justify_content',
            //   label: 'Justify content',
            //   type: 'select',
            //   default: 'space-between',
            //   options: ['flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'space-evenly'],
            // },
            // {
            //   name: 'theme_component_title_align_items',
            //   label: 'Align items',
            //   type: 'select',
            //   default: 'center',
            //   options: ['flex-start', 'flex-end', 'center', 'baseline', 'stretch'],
            // },
            {
                name: "theme_component_title_border_bottom_width",
                label: "Border bottom width",
                type: "number",
                endAdornment: "px",
                default: 1
            },
            {
                name: "theme_component_title_border_bottom_color",
                label: "Border bottom color",
                type: "color",
                default: theme.palette.divider
            }, 
        ],
        configuration: []
    });
};

// EXTERNAL MODULE: ./src/contexts/HighlightContext/Highlight.tsx
var Highlight = __webpack_require__(78958);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 2 modules
var Container = __webpack_require__(53156);
;// CONCATENATED MODULE: ./src/components/Title/Title.tsx










var Title_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var Root = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Container/* default */.Z, {
    target: "e15gjue10"
})(function(param) {
    var theme = param.theme;
    return {
        borderBottomWidth: theme.theme_component_title_border_bottom_width ? "".concat(theme.theme_component_title_border_bottom_width, "px") : 0,
        borderBottomStyle: "solid",
        borderBottomColor: theme.theme_component_title_border_bottom_color || theme.palette.divider,
        color: theme.theme_component_title_color || theme.palette.text.primary,
        paddingTop: theme.spacing(1.25),
        paddingBottom: theme.spacing(1.25),
        textTransform: "capitalize"
    };
});
var TypographyStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Title_Typography, {
    target: "e15gjue11"
})(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        textTransform: "none",
        color: theme.theme_component_title_title_color || "inherit",
        "& > a": {
            color: theme.theme_component_title_title_color || theme.palette.text.primary,
            "&:hover": {
                color: theme.theme_component_title_link_hover_color || theme.palette.action.hover
            },
            "&:active": {
                color: theme.theme_component_title_link_active_color || theme.palette.action.active
            }
        }
    };
});
var Title = function(props) {
    var disableGutters = props.disableGutters, children = props.children, className = props.className, style = props.style, childStyle = props.childStyle, other = (0,_object_without_properties/* default */.Z)(props, [
        "disableGutters",
        "children",
        "className",
        "style",
        "childStyle"
    ]);
    var titleRef = react.useRef(null);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Root, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        maxWidth: false,
        disableGutters: disableGutters,
        className: className,
        style: style
    }, useEditorHandlers("Title")), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TypographyStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: titleRef,
            style: childStyle
        }, other), {
            children: children
        }))
    }));
};

;// CONCATENATED MODULE: ./src/components/Title/index.ts



/***/ }),

/***/ 63605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ DynamicPage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-markdown/lib/index.js + 116 modules
var lib = __webpack_require__(1818);
// EXTERNAL MODULE: ./node_modules/remark-gfm/lib/index.js + 57 modules
var remark_gfm_lib = __webpack_require__(3);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/index.mjs
var react_intersection_observer = __webpack_require__(42708);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(29769);
// EXTERNAL MODULE: ./src/contexts/CursorContext/Cursor.tsx
var Cursor = __webpack_require__(52746);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
;// CONCATENATED MODULE: ./src/containers/GameA/@editor/index.ts


var useEditorHandlers = function(name) {
    var theme = (0,useTheme/* default */.Z)();
    return (0,Cursor/* useCursorHandlers */.h)({
        name: name,
        styles: [
            {
                name: "theme_component_game_description_background_color",
                label: "Description Section Background Color",
                type: "color",
                default: theme.palette.secondary.dark,
                helperText: "Description area background Color"
            },
            {
                name: "theme_component_game_description_font_color",
                label: "Description Section Font Color",
                type: "color",
                default: theme.palette.secondary.light,
                helperText: "Description area background Color"
            }, 
        ],
        configuration: [
            {
                name: "component_game_player_header_style",
                label: "Header layout style",
                type: "select",
                default: "full",
                options: [
                    "hidden",
                    "minimal",
                    "full"
                ]
            },
            {
                name: "component_walk_through_publisher_id",
                label: "Tubia publisher identifier",
                type: "text",
                helperText: "The publisher identifier can be requested through your account manager."
            },
            {
                name: "component_share_enable_web_api",
                label: "Enable share button",
                type: "checkbox",
                default: false,
                helperText: "Will open the client device its default sharing options (only on mobile devices)."
            },
            {
                name: "component_share_enable_embed_clipboard",
                label: "Enable embed button",
                type: "checkbox",
                default: false,
                helperText: "Will add the game URL to the client its clipboard."
            },
            {
                name: "component_game_mobile_play_button_background_color",
                label: "Mobile Play Button Background Color",
                type: "text",
                helperText: "On Mobile Game Page is changing for navigator devices"
            },
            {
                name: "component_game_mobile_play_button_color",
                label: "Mobile Play Button Font Color",
                type: "text",
                helperText: "On Mobile Game Page is changing for navigator devices"
            }, 
        ]
    });
};

// EXTERNAL MODULE: ./src/contexts/AppContext/index.tsx + 6 modules
var AppContext = __webpack_require__(13560);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js + 1 modules
var colorManipulator = __webpack_require__(8423);
// EXTERNAL MODULE: ./src/contexts/HighlightContext/Highlight.tsx
var Highlight = __webpack_require__(78958);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
;// CONCATENATED MODULE: ./src/utils/truncate-string.ts
var truncateString = function(str, n, useWordBoundary) {
    if (str.length <= n) {
        return str;
    }
    var subString = str.substr(0, n - 1); // the original check
    return "".concat(useWordBoundary ? subString.substr(0, subString.lastIndexOf(" ")) : subString, "...");
};
/* harmony default export */ var truncate_string = ({
    truncateString: truncateString
});

// EXTERNAL MODULE: ./src/components/ImageLoaderWrapper/index.ts + 2 modules
var ImageLoaderWrapper = __webpack_require__(95073);
// EXTERNAL MODULE: ./src/components/PaperColorElevation/index.ts + 1 modules
var PaperColorElevation = __webpack_require__(80830);
// EXTERNAL MODULE: ./src/components/Title/index.ts + 2 modules
var Title = __webpack_require__(61546);
// EXTERNAL MODULE: ./src/components/BreadCrumbs/index.ts + 2 modules
var BreadCrumbs = __webpack_require__(70055);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Share.js
var Share = __webpack_require__(11359);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Code.js
var Code = __webpack_require__(96214);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowDownward.js
var ArrowDownward = __webpack_require__(26613);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowUpward.js
var ArrowUpward = __webpack_require__(54364);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 2 modules
var Container = __webpack_require__(53156);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var dist_lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./src/types/enum.ts
var types_enum = __webpack_require__(95753);
;// CONCATENATED MODULE: ./src/containers/GameA/GameA.tsx

































//import UAgent from '../../utils/u-agent';

var adsRequestModule = __webpack_require__.e(/* import() */ 8505).then(__webpack_require__.bind(__webpack_require__, 18505)).then(function(module) {
    return module.adsRequest;
});
var GameFrame = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1945), __webpack_require__.e(1813)]).then(__webpack_require__.bind(__webpack_require__, 71813)).then(function(mod) {
        return mod.GameFrame;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(71813)
            ];
        }
    },
    ssr: false
});
var AdvertisementSlot = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 29918)).then(function(mod) {
        return mod.AdvertisementSlot;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29918)
            ];
        }
    },
    ssr: false
});
var CollectionSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7839).then(__webpack_require__.bind(__webpack_require__, 67839)).then(function(mod) {
        return mod.CollectionSection;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(67839)
            ];
        }
    },
    ssr: false
});
var CarouselList = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4248), __webpack_require__.e(4821), __webpack_require__.e(8892)]).then(__webpack_require__.bind(__webpack_require__, 24905)).then(function(mod) {
        return mod.CarouselList;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24905)
            ];
        }
    },
    ssr: false
});
var GameA_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var GameDesktop = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(PaperColorElevation/* PaperColorElevation */.z, {
    target: "erkbij0"
})(function(param) {
    var theme = param.theme;
    return {
        boxShadow: theme.shadows[0],
        width: "100%"
    };
});
var GameMobile = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(PaperColorElevation/* PaperColorElevation */.z, {
    target: "erkbij1"
})(function(param) {
    var theme = param.theme;
    return {
        boxShadow: theme.shadows[0],
        position: "relative",
        padding: theme.spacing(2, 2),
        margin: theme.spacing(0)
    };
});
var GameHeader = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "erkbij2"
})(function(param) {
    var theme = param.theme, headerLayout = param.headerLayout;
    var styles = {};
    if (headerLayout === types_enum/* GameHeaderLayoutEnum.FULL */.k.FULL) {
        styles = (0,_define_property/* default */.Z)({}, theme.breakpoints.up("sm"), {
            height: "90px"
        });
    }
    return (0,_object_spread/* default */.Z)({
        display: "flex",
        alignItems: "center",
        width: "100%",
        marginBottom: 0,
        padding: theme.spacing(1.5)
    }, styles);
});
var GameHeaderMeta = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "erkbij3"
})(function(param) {
    var theme = param.theme;
    return {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        width: "100%",
        padding: theme.spacing(0, 0, 0, 2),
        // overflow: 'hidden',
        "& > h1": (0,_define_property/* default */.Z)({}, theme.breakpoints.up("sm"), {
            textAlign: theme.direction === "rtl" ? "right" : "left",
            margin: theme.spacing(0)
        }),
        "& > span": (0,_define_property/* default */.Z)({
            display: "none"
        }, theme.breakpoints.up("sm"), {
            display: "block",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            color: (0,colorManipulator/* darken */._j)(theme.palette.text.primary, 0.05),
            minWidth: "0"
        })
    };
});
var GameHeaderImage = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "erkbij4"
})(function(param) {
    var theme = param.theme, headerLayout = param.headerLayout;
    var styles = {};
    if (headerLayout === types_enum/* GameHeaderLayoutEnum.FULL */.k.FULL) {
        styles = {
            width: 65,
            height: 65
        };
    } else {
        styles = (0,_define_property/* default */.Z)({
            display: "none"
        }, theme.breakpoints.up("sm"), {
            display: "block",
            float: "left",
            width: 30,
            height: 30
        });
    }
    return styles;
});
var AdvertisementSlotStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(AdvertisementSlot, {
    target: "erkbij5"
})(function(param) {
    var theme = param.theme;
    return {
        boxShadow: theme.shadows[0],
        width: "fit-content",
        margin: "auto"
    };
});
var AdvertisementSlotContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(PaperColorElevation/* PaperColorElevation */.z, {
    target: "erkbij6"
})(function(param) {
    var theme = param.theme;
    return {
        padding: 0,
        boxShadow: theme.shadows[0]
    };
});
var Section = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(PaperColorElevation/* PaperColorElevation */.z, {
    target: "erkbij7"
})(function(param) {
    var theme = param.theme;
    return {
        position: "relative"
    };
});
var SectionDescription = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(GameA_Typography, {
    target: "erkbij8"
})(function(param) {
    var theme = param.theme;
    return {
        padding: theme.spacing(2),
        color: theme.theme_component_game_description_font_color || theme.palette.secondary.light,
        backgroundColor: theme.theme_component_game_description_background_color || theme.palette.secondary.dark
    };
});
var DescriptionTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Title/* Title */.D, {
    target: "erkbij9"
})(function(param) {
    var theme = param.theme;
    return {
        color: theme.theme_component_game_description_font_color || theme.palette.secondary.light,
        backgroundColor: theme.theme_component_game_description_background_color || theme.palette.secondary.dark,
        h1: {
            color: theme.theme_component_game_description_font_color || theme.palette.secondary.light,
            backgroundColor: theme.theme_component_game_description_background_color || theme.palette.secondary.dark
        }
    };
});
var GameA = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var game = props.game, global = props.global, pageContext = props.pageContext;
    var t = (0,esm/* useTranslation */.$G)("game_a").t;
    var theme = (0,useTheme/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var ref7 = (0,react_intersection_observer/* useInView */.YD)(), ref8 = ref7.ref, inView = ref7.inView;
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var ref9 = appContext.useConfig(), assetUrl = ref9.assetUrl, componentOptions = ref9.componentOptions, pageOptions = ref9.pageOptions, project = ref9.project;
    var gamePageLayout = (ref = pageOptions.find(function(page) {
        return page.name === "game";
    })) === null || ref === void 0 ? void 0 : (ref1 = ref.layouts) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.imports) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.component;
    // @ts-ignore
    //const [uAgent] = React.useState(new UAgent({ debug: false }));
    var ref10 = (0,_sliced_to_array/* default */.Z)(react.useState(dist_lib/* isMobile */.tq), 2), gameRunning = ref10[0], setGameRunning = ref10[1];
    var ref11 = (0,_sliced_to_array/* default */.Z)(react.useState(""), 2), description = ref11[0], setDescription = ref11[1];
    var ref12 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), domLoaded = ref12[0], setDomLoaded = ref12[1];
    var ref13 = (0,_sliced_to_array/* default */.Z)(react.useState(true), 2), descriptionIsTruncated = ref13[0], setDescriptionIsTruncated = ref13[1];
    var descriptionTruncateLength = 350;
    var md = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("md"));
    var header_lift = project.features.ads.header_lift;
    var swiperOptions = {
        breakpoints: {
            900: {
                slidesPerView: 4,
                slidesPerGroup: 4
            },
            600: {
                slidesPerView: 3,
                slidesPerGroup: 3
            },
            0: {
                slidesPerView: 2,
                slidesPerGroup: 2
            }
        }
    };
    var publisherId = componentOptions.component_walk_through_publisher_id;
    var layout = gamePageLayout === "ConservativeGame" ? types_enum/* LayoutTypeEnum.CONSERVATIVE */.Du.CONSERVATIVE : gamePageLayout === "ModerateGame" ? types_enum/* LayoutTypeEnum.MODERATE */.Du.MODERATE : gamePageLayout === "AggressiveGame" ? types_enum/* LayoutTypeEnum.AGGRESSIVE */.Du.AGGRESSIVE : types_enum/* LayoutTypeEnum.DEFAULT */.Du.DEFAULT;
    var enableShare = typeof componentOptions.component_share_enable_web_api === "boolean" ? componentOptions.component_share_enable_web_api : true;
    var enableClipBoard = typeof componentOptions.component_share_enable_embed_clipboard === "boolean" ? componentOptions.component_share_enable_embed_clipboard : true;
    var headerLayout = componentOptions.component_game_player_header_style || types_enum/* GameHeaderLayoutEnum.FULL */.k.FULL;
    var layoutAreas = /* componentOptions.component_game_player_areas || */ [
        types_enum/* GameLayoutAreaEnum.GAME */.o_.GAME,
        types_enum/* GameLayoutAreaEnum.DESCRIPTION */.o_.DESCRIPTION,
        types_enum/* GameLayoutAreaEnum.ADVERTISEMENT */.o_.ADVERTISEMENT,
        types_enum/* GameLayoutAreaEnum.COLLECTION_POPULAR */.o_.COLLECTION_POPULAR,
        types_enum/* GameLayoutAreaEnum.CATEGORY */.o_.CATEGORY,
        types_enum/* GameLayoutAreaEnum.COLLECTION_LATEST */.o_.COLLECTION_LATEST, 
    ];
    var cardType = componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_game_carousel_card_type;
    var startPlayButtonBackgroundColor = componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_game_mobile_play_button_background_color;
    var startPlayButtonColor = componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_game_mobile_play_button_color;
    var banners = [
        "idhb-middle-728"
    ];
    var titleRef = react.useRef(null);
    var subtitleRef = react.useRef(null);
    var descriptionRef = react.useRef(null);
    var buttonMobilePlayRef = react.useRef(null);
    var buttonMobileShareRef = react.useRef(null);
    var buttonMobileClipBoardRef = react.useRef(null);
    var buttonMoreRef = react.useRef(null);
    var toggleTruncateDescription = function() {
        setDescriptionIsTruncated(!descriptionIsTruncated);
        if (descriptionIsTruncated) {
            setDescription((game === null || game === void 0 ? void 0 : game.description) || "");
        } else {
            setDescription(truncateString((game === null || game === void 0 ? void 0 : game.description) || "", descriptionTruncateLength, true));
        }
    };
    var handleToggleGame = function() {
        setGameRunning(function(running) {
            return !running;
        });
    };
    var openSnackbar = function(value) {
        if (value === "share") {
            if (navigator.share) {
                var ref;
                navigator.share({
                    url: (ref = window.location) === null || ref === void 0 ? void 0 : ref.href
                });
            } else {
                console.error("Browser doesn't support Web Share API");
            }
        } else {
            navigator.clipboard.writeText(game.src || "");
        // Todo: HUZ2ERA-1108 - Enable snackbar
        // if (snackbar) snackbar({ message: 'Copied to clipboard', variant: 'success' });
        }
    };
    // Modified to conditionally execute adsRequest based on header_lift
    var requestAds = react.useCallback(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(bannersList) {
            var adsRequest, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!header_lift) return [
                            3,
                            4
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            adsRequestModule
                        ];
                    case 2:
                        adsRequest = _state.sent();
                        adsRequest(bannersList);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error("Failed to load adsRequest:", error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(bannersList) {
            return _ref.apply(this, arguments);
        };
    }(), [
        header_lift
    ]);
    react.useEffect(function() {
        requestAds(banners);
        setDomLoaded(true);
    }, [
        requestAds
    ]);
    react.useEffect(function() {
        if (dist_lib/* isMobile */.tq && !gameRunning && router.query.slug) {
            setGameRunning(true);
        }
    }, [
        router.query.slug
    ]);
    react.useEffect(function() {
        var events = router.events;
        var handleRouteChange = function() {
            requestAds(banners);
        };
        events.on("routeChangeComplete", handleRouteChange);
        events.on("hashChangeComplete", handleRouteChange);
        return function() {
            events.off("routeChangeComplete", handleRouteChange);
            events.off("hashChangeComplete", handleRouteChange);
        };
    }, [
        router,
        requestAds
    ]);
    react.useEffect(function() {
        setDescription(truncateString(game.description || "", descriptionTruncateLength, true));
    }, [
        game
    ]);
    var checkSectionVisibility = function(sectionName) {
        var grids = layoutAreas.map(function(area) {
            return '"'.concat(area, '"');
        }).join("\r\n");
        return grids.includes(sectionName);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        maxWidth: "md",
        disableGutters: true,
        ref: ref8
    }, useEditorHandlers("Game Page")), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                sx: {
                    gridArea: "breadcrumbs"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
                    maxWidth: false,
                    disableGutters: md,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BreadCrumbs/* BreadCrumbs */.b, {
                        breadcrumbs: pageContext.breadcrumbs
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
                sx: {
                    display: "grid",
                    gridTemplateRows: "auto",
                    gridRowGap: "32px",
                    gridTemplateAreas: layoutAreas.map(function(area) {
                        return '"'.concat(area, '"');
                    }).join("\r\n")
                },
                children: [
                    domLoaded && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
                        sx: {
                            gridArea: types_enum/* GameLayoutAreaEnum.GAME */.o_.GAME,
                            minWidth: 0
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist_lib/* BrowserView */.I3, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
                                    maxWidth: false,
                                    disableGutters: md,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GameDesktop, {
                                        elevation: 1,
                                        children: [
                                            headerLayout !== types_enum/* GameHeaderLayoutEnum.HIDDEN */.k.HIDDEN && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GameHeader, {
                                                headerLayout: headerLayout,
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GameHeaderImage, {
                                                        headerLayout: headerLayout,
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageLoaderWrapper/* ImageLoaderWrapper */.T, {
                                                            src: "".concat(assetUrl).concat(game.images.cover1x1 || game.images.cover, "/"),
                                                            width: headerLayout === types_enum/* GameHeaderLayoutEnum.FULL */.k.FULL ? 64 : 32,
                                                            height: headerLayout === types_enum/* GameHeaderLayoutEnum.FULL */.k.FULL ? 64 : 32,
                                                            alt: "".concat(game.name),
                                                            priority: true,
                                                            layout: "responsive"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GameHeaderMeta, {
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GameA_Typography, {
                                                                ref: titleRef,
                                                                variant: "h1",
                                                                component: "h1",
                                                                children: game.name
                                                            }),
                                                            headerLayout === types_enum/* GameHeaderLayoutEnum.FULL */.k.FULL && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GameA_Typography, {
                                                                ref: subtitleRef,
                                                                variant: "subtitle1",
                                                                component: "span",
                                                                children: game.description
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                                                sx: {
                                                    aspectRatio: "16/9",
                                                    backgroundColor: theme.palette.grey["900"]
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GameFrame, {
                                                    game: game,
                                                    start: true
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist_lib/* MobileView */.$, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container/* default */.Z, {
                                    maxWidth: false,
                                    disableGutters: md,
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GameFrame, {
                                            game: game,
                                            start: gameRunning,
                                            onStop: handleToggleGame,
                                            enableOrientationLock: true,
                                            enableDraggableMenu: true,
                                            enableResponsive: true
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GameMobile, {
                                            elevation: 1,
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                    style: {
                                                        display: "flex",
                                                        flexDirection: "row"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                                                            sx: {
                                                                display: "flex"
                                                            },
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageLoaderWrapper/* ImageLoaderWrapper */.T, {
                                                                src: "".concat(assetUrl).concat(game.images.cover1x1 || game.images.cover, "/"),
                                                                width: 100,
                                                                height: 100,
                                                                alt: "".concat(game.name),
                                                                priority: true
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GameHeaderMeta, {
                                                            children: [
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GameA_Typography, {
                                                                    ref: titleRef,
                                                                    variant: "h1",
                                                                    component: "h1",
                                                                    children: game.name
                                                                }),
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                                                                    ref: buttonMobilePlayRef,
                                                                    onClick: handleToggleGame,
                                                                    variant: "contained",
                                                                    sx: {
                                                                        marginTop: "auto",
                                                                        background: startPlayButtonBackgroundColor,
                                                                        color: startPlayButtonColor
                                                                    },
                                                                    children: t("button.continue_playing", "Start playing")
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                (enableShare || enableClipBoard) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                    style: {
                                                        padding: theme.spacing(2, 0, 0)
                                                    },
                                                    children: [
                                                        enableShare && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                                                            ref: buttonMobileShareRef,
                                                            variant: "contained",
                                                            size: "small",
                                                            color: "secondary",
                                                            onClick: function() {
                                                                return openSnackbar("share");
                                                            },
                                                            style: {
                                                                marginRight: theme.spacing(1),
                                                                backgroundColor: theme.palette.background.paper,
                                                                color: theme.palette.text.primary
                                                            },
                                                            startIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Share/* default */.Z, {}),
                                                            children: t("button.share", "Share")
                                                        }),
                                                        enableClipBoard && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                                                            ref: buttonMobileClipBoardRef,
                                                            variant: "contained",
                                                            size: "small",
                                                            color: "secondary",
                                                            onClick: function() {
                                                                return openSnackbar("embed");
                                                            },
                                                            style: {
                                                                marginRight: theme.spacing(1),
                                                                backgroundColor: theme.palette.background.paper,
                                                                color: theme.palette.text.primary
                                                            },
                                                            startIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Code/* default */.Z, {}),
                                                            children: t("button.embed", "Copy link")
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    !componentOptions.component_ads_disabled && !componentOptions.component_game_ads_middle_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                        sx: {
                            gridArea: types_enum/* GameLayoutAreaEnum.ADVERTISEMENT */.o_.ADVERTISEMENT,
                            minWidth: 0
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlotContainer, {
                            elevation: 0,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlotStyled, {
                                slotIdentifier: layout === types_enum/* LayoutTypeEnum.AGGRESSIVE */.Du.AGGRESSIVE ? componentOptions.component_aggressive_game_middle_id : layout === types_enum/* LayoutTypeEnum.MODERATE */.Du.MODERATE ? componentOptions.component_moderate_game_middle_id : layout === types_enum/* LayoutTypeEnum.CONSERVATIVE */.Du.CONSERVATIVE ? componentOptions.component_conservative_game_middle_id : header_lift ? banners[0] : componentOptions.component_game_ads_id,
                                variant: md ? "970x250" : "320x50",
                                elevation: 1
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                        sx: {
                            gridArea: types_enum/* GameLayoutAreaEnum.DESCRIPTION */.o_.DESCRIPTION,
                            minWidth: 0
                        },
                        children: inView && checkSectionVisibility(types_enum/* GameLayoutAreaEnum.DESCRIPTION */.o_.DESCRIPTION) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
                            maxWidth: false,
                            disableGutters: md,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section, {
                                elevation: 1,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DescriptionTitle, {
                                        variant: headerLayout === "hidden" ? "h1" : "h2",
                                        component: headerLayout === "hidden" ? "h1" : "span",
                                        children: game.name
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionDescription, {
                                        ref: descriptionRef,
                                        variant: "body1",
                                        paragraph: true,
                                        gutterBottom: true,
                                        children: [
                                            description,
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                style: {
                                                    display: descriptionIsTruncated ? "none" : "block"
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(lib/* Markdown */.U, {
                                                    remarkPlugins: [
                                                        remark_gfm_lib/* default */.Z
                                                    ],
                                                    children: pageContext === null || pageContext === void 0 ? void 0 : pageContext.seoContent
                                                })
                                            })
                                        ]
                                    }),
                                    game.description && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                                        ref: buttonMoreRef,
                                        variant: "contained",
                                        onClick: toggleTruncateDescription,
                                        "aria-label": t("more_link", "More"),
                                        sx: {
                                            position: "absolute",
                                            bottom: 0,
                                            left: "50%",
                                            minWidth: 0,
                                            width: theme.spacing(5),
                                            height: theme.spacing(5),
                                            margin: "auto",
                                            borderRadius: "100%",
                                            transform: "translate(-50%, 50%)"
                                        },
                                        children: !descriptionIsTruncated ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowUpward/* default */.Z, {}) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowDownward/* default */.Z, {})
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                        sx: {
                            gridArea: types_enum/* GameLayoutAreaEnum.CATEGORY */.o_.CATEGORY,
                            minWidth: 0
                        },
                        children: ((ref5 = game === null || game === void 0 ? void 0 : game.categories[0]) === null || ref5 === void 0 ? void 0 : ref5.slug) && inView && checkSectionVisibility(types_enum/* GameLayoutAreaEnum.CATEGORY */.o_.CATEGORY) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CollectionSection, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title/* Title */.D, {
                                    component: "h3",
                                    variant: "h3",
                                    children: t("category", (ref6 = game === null || game === void 0 ? void 0 : game.categories[0]) === null || ref6 === void 0 ? void 0 : ref6.slug)
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselList, (0,_object_spread/* default */.Z)({
                                    padding: theme.spacing(2),
                                    items: global.category || [],
                                    cardOptions: {
                                        width: componentOptions.component_card_width || 512,
                                        height: componentOptions.component_card_height || 288,
                                        sizes: "(min-width:1200px) 16.666vw, (min-width:900px) 25vw, (min-width:600px) 33.333vw, 50vw",
                                        layout: "responsive",
                                        template: cardType
                                    }
                                }, swiperOptions))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                        sx: {
                            gridArea: types_enum/* GameLayoutAreaEnum.COLLECTION_LATEST */.o_.COLLECTION_LATEST,
                            minWidth: 0
                        },
                        children: inView && checkSectionVisibility(types_enum/* GameLayoutAreaEnum.COLLECTION_LATEST */.o_.COLLECTION_LATEST) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CollectionSection, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title/* Title */.D, {
                                    component: "h3",
                                    variant: "h3",
                                    children: t("latest_header", "Latest")
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselList, (0,_object_spread/* default */.Z)({
                                    padding: theme.spacing(2),
                                    items: global.latest || [],
                                    cardOptions: {
                                        width: componentOptions.component_card_width || 512,
                                        height: componentOptions.component_card_height || 288,
                                        sizes: "(min-width:1200px) 16.666vw, (min-width:900px) 25vw, (min-width:600px) 33.333vw, 50vw",
                                        layout: "responsive",
                                        template: cardType
                                    }
                                }, swiperOptions))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                        sx: {
                            gridArea: types_enum/* GameLayoutAreaEnum.COLLECTION_POPULAR */.o_.COLLECTION_POPULAR,
                            minWidth: 0
                        },
                        children: inView && checkSectionVisibility(types_enum/* GameLayoutAreaEnum.COLLECTION_POPULAR */.o_.COLLECTION_POPULAR) && Array.isArray(global.popular) && global.popular.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CollectionSection, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title/* Title */.D, {
                                    component: "h3",
                                    variant: "h3",
                                    children: t("popular_header", "Popular")
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselList, (0,_object_spread/* default */.Z)({
                                    padding: theme.spacing(2),
                                    items: global.popular || [],
                                    cardOptions: {
                                        width: componentOptions.component_card_width || 512,
                                        height: componentOptions.component_card_height || 288,
                                        sizes: "(min-width:1200px) 16.666vw, (min-width:900px) 25vw, (min-width:600px) 33.333vw, 50vw",
                                        layout: "responsive",
                                        template: cardType
                                    }
                                }, swiperOptions))
                            ]
                        })
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/containers/GameA/index.ts


;// CONCATENATED MODULE: ./src/generated/game/index.tsx




function View(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GameA, (0,_object_spread/* default */.Z)({}, props))
    });
}

// EXTERNAL MODULE: ./src/layouts/BaseLayout/index.tsx + 12 modules
var BaseLayout = __webpack_require__(97691);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/utils/localize-helpers.ts
var localize_helpers = __webpack_require__(98751);
// EXTERNAL MODULE: ./src/components/SubscriptionModal/index.tsx
var SubscriptionModal = __webpack_require__(96410);
;// CONCATENATED MODULE: ./src/pages/game/[slug].tsx













var Script = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("script", {
    target: "e1dymhic0"
})();
var __N_SSG = true;
function DynamicPage(props) {
    var ref, ref1;
    var game = props.game, title = props.title, pageContext = props.pageContext;
    var ref2 = (0,esm/* useTranslation */.$G)([
        "common",
        "game"
    ]), t = ref2.t, i18n = ref2.i18n;
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var ref3 = appContext.useConfig(), name = ref3.name, url = ref3.url, assetAbsoluteUrl = ref3.assetAbsoluteUrl, appIconId = ref3.appIconId, noGameFollow = ref3.noGameFollow, componentOptions = ref3.componentOptions;
    var router = (0,next_router.useRouter)();
    var paths = (0,localize_helpers/* getLocalizedPaths */.mT)(router);
    var siteUrl = "".concat(url === null || url === void 0 ? void 0 : url.replace(/\/+$/, ""));
    var metaTitle = ((ref = game.meta) === null || ref === void 0 ? void 0 : ref.title) || title;
    var seoTitle = i18n.exists("game:title", {
        fallbackLng: pageContext.locale
    }) ? t("game:title", {
        title: metaTitle
    }) : t("common:title", {
        title: metaTitle
    });
    var metaDescription = ((ref1 = game.meta) === null || ref1 === void 0 ? void 0 : ref1.description) || game.description;
    var seoDescription = i18n.exists("game:description", {
        fallbackLng: pageContext.locale
    }) ? t("game:description", {
        title: metaTitle,
        description: metaDescription
    }) : t("common:description", {
        title: metaTitle,
        description: metaDescription
    });
    var seoContent;
    // Customized SEO
    var seo = appContext.useSeo().seo;
    // Homepage page
    if (seo === null || seo === void 0 ? void 0 : seo.games) {
        var gamesSeo = Object.keys(seo.games);
        // Current game matches in SEO
        if (gamesSeo.includes(game.gdGameId) && router.locale) {
            var currentGame = seo.games[game.gdGameId];
            // Current game matches the same language
            if (currentGame[router.locale]) {
                var ref4, ref5, ref6;
                // Current game matches the same language has title
                if ((ref4 = currentGame[router.locale]) === null || ref4 === void 0 ? void 0 : ref4.title) {
                    var ref7;
                    seoTitle = (ref7 = currentGame[router.locale]) === null || ref7 === void 0 ? void 0 : ref7.title;
                }
                // Current game matches the same language has description
                if ((ref5 = currentGame[router.locale]) === null || ref5 === void 0 ? void 0 : ref5.description) {
                    var ref8;
                    seoDescription = (ref8 = currentGame[router.locale]) === null || ref8 === void 0 ? void 0 : ref8.description;
                }
                // Current game already added seo description
                if ((ref6 = currentGame[router.locale]) === null || ref6 === void 0 ? void 0 : ref6.gameDescription) {
                    var ref9;
                    seoContent = (ref9 = currentGame[router.locale]) === null || ref9 === void 0 ? void 0 : ref9.gameDescription;
                }
            }
        }
    }
    var pageContextWithPaths = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageContext), {
        paths: paths,
        seoContent: seoContent
    });
    var showSubscriptionModal = componentOptions.component_project_subscription_mode;
    var ogtitle = componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_facebook_og_title;
    var ogDescription = componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_facebook_og_description;
    var ssrSeo;
    if ((props === null || props === void 0 ? void 0 : props.seo) && props.seo[0]) {
        var ref10;
        var seoObject = props.seo[0];
        if (((ref10 = seoObject.pages) === null || ref10 === void 0 ? void 0 : ref10.game) && router.locale) {
            var seoCurrentLanguage = seoObject.pages.game[router.locale];
            if (seoCurrentLanguage.json_ld) {
                ssrSeo = seoCurrentLanguage.json_ld;
            }
        }
    }
    var languageAlternatives = (0,localize_helpers/* getLocalizedPaths */.mT)(router).map(function(path) {
        return {
            hrefLang: path.locale,
            href: (ssrSeo === null || ssrSeo === void 0 ? void 0 : ssrSeo.url) ? "".concat(ssrSeo.url).concat((0,localize_helpers/* getLocalizedPaths */.mT)(router)[0].path) : "".concat(url).concat(path.path)
        };
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            showSubscriptionModal && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubscriptionModal/* SubscriptionModal */.u, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_seo_module/* NextSeo */.PB, {
                nofollow: noGameFollow ? true : false,
                noindex: noGameFollow ? true : false,
                title: seoTitle,
                description: seoDescription,
                languageAlternates: languageAlternatives.map(function(locale) {
                    return {
                        hrefLang: locale.hrefLang,
                        href: locale.href
                    };
                }),
                canonical: "".concat(ssrSeo === null || ssrSeo === void 0 ? void 0 : ssrSeo.url).concat((0,localize_helpers/* getLocalizedPaths */.mT)(router)[0].path),
                openGraph: {
                    title: ogtitle ? ogtitle : seoTitle,
                    description: ogDescription ? ogDescription : seoDescription,
                    url: componentOptions.component_facebook_og_url ? componentOptions.component_facebook_og_url : url,
                    type: "website",
                    images: [
                        {
                            url: (componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_facebook_og_image_url) ? componentOptions.component_facebook_og_image_url : "".concat(url, "/games/media/").concat(game.images.cover1x1 || game.images.cover, "/?ar[r]=1x1&ar[w]=512&fmt=.png"),
                            width: 512,
                            height: 512,
                            alt: "".concat(seoTitle)
                        }, 
                    ]
                },
                twitter: {
                    cardType: "summary_large_image"
                }
            }),
            ssrSeo && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Script, {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        "@type": ssrSeo["@type"],
                        "@context": ssrSeo["@context"] || "https://schema.org"
                    }, Object.keys(ssrSeo).reduce(function(acc, key) {
                        if (key !== "@context" && key !== "@type") {
                            acc[key] = ssrSeo[key];
                        }
                        return acc;
                    }, {})), {
                        url: "".concat(ssrSeo.url).concat((0,localize_helpers/* getLocalizedPaths */.mT)(router)[0].path)
                    }))
                }
            }),
            ssrSeo && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Script, {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify((0,_object_spread/* default */.Z)({
                        "@type": "Game",
                        "@context": ssrSeo["@context"] || "https://schema.org"
                    }, Object.keys(ssrSeo).reduce(function(acc, key) {
                        if (key !== "@context" && key !== "@type") {
                            acc[key] = ssrSeo[key];
                        }
                        return acc;
                    }, {})))
                }
            }),
            !componentOptions.component_collection_json_ld_is_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_seo_module/* ArticleJsonLd */.dX, {
                type: "NewsArticle",
                url: "".concat(siteUrl).concat(router.asPath),
                title: "".concat(seoTitle),
                images: Object.values(game.images).filter(function(image) {
                    return image !== null;
                }).map(function(image) {
                    return "".concat(assetAbsoluteUrl).concat(image, "/");
                }),
                datePublished: "".concat(game.publishedAt),
                authorName: "GameDistribution",
                publisherName: "".concat(name),
                publisherLogo: "".concat(assetAbsoluteUrl).concat(appIconId),
                description: "".concat(seoDescription)
            }),
            !componentOptions.component_breadcrumb_json_ld_is_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_seo_module/* BreadcrumbJsonLd */.gR, {
                itemListElements: pageContextWithPaths.breadcrumbs.map(function(crumb, index) {
                    return {
                        position: index + 1,
                        name: crumb.name,
                        item: crumb.href
                    };
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(View, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                pageContext: pageContextWithPaths
            }))
        ]
    });
}
// Adding getLayout property. Allowing us to return a React component for the layout.
// This allows us to define the layout on a per-page basis. Since we're returning a function,
// we can have complex nested layouts if desired.
DynamicPage.getLayout = function getLayout(page) {
    var props = page.props;
    var pageContext = props.pageContext;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BaseLayout/* BaseLayout */.I, {
        pageType: "game",
        pageContext: pageContext,
        children: page
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8010,2607,5730,5675,4638,7291,8786,9419,7637,3236,9774,2888,179], function() { return __webpack_exec__(15800); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);